<app-page-frame frameTitle="User Management" titleIcon="bi-people" homeRoute="/user-management">
    <router-outlet></router-outlet>
</app-page-frame>
